export default __webpack_public_path__ + "static/media/delete-icon.26585718.svg";